import { IMAGE_ALT } from '../../seo/imageAltText';
import PictureImage from '../../components/Common/PictureImage';
import { Link } from 'react-router-dom';
import React from "react";
import { FBA_PREP_CONTACT_PATH, FBA_PREP_PRIMARY_CTA } from './fbaPrepCta';
import "./Fbabanner.css";

const issues = [
  "Prevent Inventory Rejections Caused by Incorrect Labelling",
  "Reduce Check-In Delays and Protect Sales Velocity",
  "Avoid Amazon Compliance Issues and Account Warnings",
  "Save Time with Expert Shipment Creation and Planning",
  "Transparent Pricing with No Hidden Prep Fees",
];

const FBABanner: React.FC<{ showPrimaryCta?: boolean }> = ({ showPrimaryCta = false }) => {
  return (
    <div className="fba-banner">
      <div className="fba-overlay" />
      <div className="fba-content">
        <div className="fba-text">
          <h2 className="fba-heading">
            Stop Losing Money to{' '}
            <span className="fba-highlight">FBA Delays, Rejections &amp; Chargebacks</span>
          </h2>
          <ul className="fba-list">
            {issues.map((issue, i) => (
              <li key={i} className="fba-list-item">
                <span className="fba-icon">
                  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                    <circle cx="10" cy="10" r="8.5" stroke="#f58030" strokeWidth="1.5" />
                    <circle cx="10" cy="10" r="3.5" stroke="#f58030" strokeWidth="1.5" />
                  </svg>
                </span>
                {issue}
              </li>
            ))}
          </ul>
          {showPrimaryCta ? (
            <Link to={FBA_PREP_CONTACT_PATH} className="fba-banner-cta">
              {FBA_PREP_PRIMARY_CTA}
            </Link>
          ) : null}
        </div>
        <div className="fba-image-wrap">
          <div className="fba-image-inner">
            <PictureImage width={800} height={800}
              src="/Images/amazon-fba-prep-warehouse-milton-keynes.webp"
              alt={IMAGE_ALT.fbaBannerWorker}
              className="fba-img" loading="lazy" />
            <div className="fba-img-overlay" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FBABanner;
